import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, mergeProps as _mergeProps, createSlots as _createSlots, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "m-auto px-8 md:px-20 pb-8" }
const _hoisted_2 = { class: "max-w-screen-2xl m-auto" }
const _hoisted_3 = { class: "flex justify-between" }
const _hoisted_4 = { class: "pt-10 text-2xl font-bold" }
const _hoisted_5 = { class: "flex items-center gap-3 py-4" }
const _hoisted_6 = { class: "text-sm" }
const _hoisted_7 = {
  key: 0,
  class: "overflow-x-scroll"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ConfermaModal = _resolveComponent("ConfermaModal")!
  const _component_NextButton = _resolveComponent("NextButton")!
  const _component_BadgeStato = _resolveComponent("BadgeStato")!
  const _component_SottoProgettoHead = _resolveComponent("SottoProgettoHead")!
  const _component_Tabs = _resolveComponent("Tabs")!
  const _component_NextSottoProgettoTable = _resolveComponent("NextSottoProgettoTable")!
  const _component_SezioneSottoProgetti = _resolveComponent("SezioneSottoProgetti")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_ConfermaModal, {
      onConfirm: _ctx.riprendi,
      onReject: _cache[0] || (_cache[0] = ($event: any) => (_ctx.conferma_visible = false)),
      backdrop: true,
      visible: _ctx.conferma_visible
    }, {
      default: _withCtx(() => _cache[3] || (_cache[3] = [
        _createTextVNode(" Confermi di voler riprendere questa versione? ")
      ])),
      _: 1
    }, 8, ["onConfirm", "visible"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h1", _hoisted_4, _toDisplayString(_ctx.sottoprogetto?.titolo), 1),
        _createVNode(_component_NextButton, {
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.conferma_visible = true)),
          variant: "outline-primary",
          class: "self-center p-1"
        }, {
          default: _withCtx(() => _cache[4] || (_cache[4] = [
            _createTextVNode(" Riprendi versione ")
          ])),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("p", _hoisted_6, [
          _cache[5] || (_cache[5] = _createElementVNode("i", { class: "icon icon-flag text-next-orange" }, null, -1)),
          _createTextVNode(" Versione " + _toDisplayString(_ctx.sottoprogetto?.major) + "." + _toDisplayString(_ctx.sottoprogetto?.minor) + " create da ", 1),
          _createElementVNode("b", null, _toDisplayString(_ctx.sottoprogetto?.created_by_label), 1),
          _createTextVNode(" il " + _toDisplayString(_ctx.$filters.toDate(_ctx.sottoprogetto?.created_at)) + " alle " + _toDisplayString(_ctx.$filters.toTime(_ctx.sottoprogetto?.created_at)), 1)
        ]),
        _createVNode(_component_BadgeStato, {
          stato: _ctx.sottoprogetto?.stato
        }, null, 8, ["stato"])
      ]),
      _createVNode(_component_SottoProgettoHead, {
        budget: _ctx.sottoprogetto?.budget ? `€ ${Number(_ctx.sottoprogetto?.budget).toLocaleValueString()}` : '-',
        totaleRicavi: _ctx.ActiveTab && _ctx.TotaleRicaviProgetto(_ctx.ActiveTab.sezioni) ? _ctx.$filters.toEuroCurrency(_ctx.TotaleRicaviProgetto(_ctx.ActiveTab.sezioni)) : '-',
        budgetProgetto: _ctx.ActiveTab && _ctx.TotaleBudgetProgetto(_ctx.ActiveTab.sezioni) ? _ctx.$filters.toEuroCurrency(_ctx.TotaleBudgetProgetto(_ctx.ActiveTab.sezioni)) : '-',
        commissioni: _ctx.ActiveTab && _ctx.TotaleCommissioniProgetto(_ctx.ActiveTab.sezioni) ? _ctx.$filters.toEuroCurrency(_ctx.TotaleCommissioniProgetto(_ctx.ActiveTab.sezioni)) : '-',
        totaleCosti: _ctx.ActiveTab && _ctx.TotaleCostiEuroProgetto(_ctx.ActiveTab.sezioni) ? _ctx.$filters.toEuroCurrency(_ctx.TotaleCostiEuroProgetto(_ctx.ActiveTab.sezioni)) : '-',
        risorseInterne: _ctx.dati && _ctx.dati.risorse_interne ? _ctx.dati.risorse_interne : '-',
        utile: _ctx.ActiveTab && _ctx.TotaleUtiliProgetto(_ctx.ActiveTab.sezioni).toLocaleValueString() ? `€ ${_ctx.TotaleUtiliProgetto(_ctx.ActiveTab.sezioni).toLocaleValueString()}` : '-',
        margine: _ctx.ActiveTab && _ctx.TotaleMolFee(_ctx.ActiveTab.sezioni) ? `${_ctx.TotaleMolFee(_ctx.ActiveTab.sezioni).toLocaleValueString()} %` : '-',
        fee: _ctx.ActiveTab && _ctx.TotaleFeesSezioni(_ctx.ActiveTab.sezioni) ? _ctx.TotaleFeesSezioni(_ctx.ActiveTab.sezioni).toLocaleValueString() : '-'
      }, null, 8, ["budget", "totaleRicavi", "budgetProgetto", "commissioni", "totaleCosti", "risorseInterne", "utile", "margine", "fee"]),
      _createVNode(_component_Tabs, {
        class: "py-8",
        tabs: _ctx.dati?.tabs,
        modelValue: _ctx.dati.active_tab,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.dati.active_tab) = $event)),
        readonly: ""
      }, null, 8, ["tabs", "modelValue"]),
      (_ctx.ActiveTab)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.ActiveTab.sezioni, (s, i) => {
              return (_openBlock(), _createBlock(_component_SezioneSottoProgetti, {
                readonly: "",
                titolo: s.titolo,
                "onUpdate:titolo": ($event: any) => ((s.titolo) = $event),
                key: s.titolo + i,
                order: i+1,
                last: i === s.length-1,
                first: i === 0,
                expanded: s.expanded,
                "onUpdate:expanded": ($event: any) => ((s.expanded) = $event),
                hideTotal: true
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_NextSottoProgettoTable, {
                    class: "w-full border-separate py-4",
                    actionClass: "relative",
                    cols: _ctx.tableHeader,
                    rows: s.ordered_records
                  }, _createSlots({ _: 2 }, [
                    _renderList(_ctx.rowCellIterator(s.ordered_records, _ctx.sottoProgettiCols), (rc, x) => {
                      return {
                        name: `td_${rc}`,
                        fn: _withCtx(({row, cell}) => [
                          _createElementVNode("span", _mergeProps({
                            class: "h-10 flex items-center w-full",
                            ref_for: true
                          }, _ctx.getProps(row, cell)), _toDisplayString(_ctx.getValue(row, cell)), 17)
                        ])
                      }
                    })
                  ]), 1032, ["cols", "rows"])
                ]),
                _: 2
              }, 1032, ["titolo", "onUpdate:titolo", "order", "last", "first", "expanded", "onUpdate:expanded"]))
            }), 128))
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}